// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2VnDw","productName":"Table_productName__1oacL"};